/*!
 * event-emitter v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.callbacks = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, fn) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }

      this.callbacks[event].push(fn);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var callbacks = this.callbacks[event];

      if (callbacks) {
        var length = callbacks.length; // eslint-disable-line prefer-destructuring

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        for (var i = 0; i < length; i++) {
          callbacks[i].apply(this, args);
        }
      }

      return this;
    }
  }, {
    key: "off",
    value: function off(event, fn) {
      if (!this.callbacks || arguments.length === 0) {
        this.callbacks = {};
        return this;
      }

      var callbacks = this.callbacks[event];

      if (!callbacks) {
        return this;
      }

      if (arguments.length === 1) {
        delete this.callbacks[event];
        return this;
      }

      for (var i = 0; i < callbacks.length; i++) {
        if (callbacks[i] === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }

      return this;
    }
  }]);

  return EventEmitter;
}();

export default EventEmitter;
